<template>
  <div class="v-select">
    <multiselect
      :value="value"
      :searchable="false"
      :allow-empty="allowEmpty"
      :open-direction="openDirection"
      :label="label"
      :trackBy="trackBy"
      :placeholder="placeholder"
      :select-label="emptyLabel"
      :selected-label="emptyLabel"
      :deselect-label="emptyLabel"
      :options="options"
      :disabled="disabled"
      :max-height="322"
      @input="setValue($event)"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

/**
 * @param {Object|String|Number} value - Значение по умолчанию
 * @param {Boolean} [allowEmpty=false] - Допускать пустое значение
 * @param {Array} options - Список доступных опций
 * @param {String} [placeholder=Выберите значение] - Подсказка
 * @param {String} [openDirection=bottom] - Направление отображения списка опций
 * @param {String} label - Свойство объекта, отображаемое в списке опций
 * @param {String} [trackBy=value] - Ключ уникального свойства объекта (для сравнения опций)
 * @param {Boolean} [disabled=false] - Отключение активности элемента
 */
export default {
  name: 'VSelect',

  components: {
    Multiselect
  },

  props: {
    value: {
      type: [Object, String, Number]
    },
    allowEmpty: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array
    },
    placeholder: {
      type: String,
      default: 'Выберите значение'
    },
    openDirection: {
      type: String,
      default: 'bottom'
    },
    label: {
      type: String
    },
    trackBy: {
      type: String,
      default: 'value'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      emptyLabel: ''
    }
  },

  methods: {
    setValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/style/scss/_vars.scss";
@import "@/assets/style/scss/_extends.scss";
@import "@/assets/style/scss/components/multiselect.scss";

$width-arrow-base: $padding-base;
$height-arrow-base: $width-arrow-base;
$select-font-size: 14px;

.multiselect__tags {
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
}
.multiselect__single {
  background-color: transparent;
}
.multiselect--active .multiselect__placeholder {
  display: block;
}
.multiselect__placeholder {
  color: inherit;
  padding-left: 5px;
  margin-bottom: 8px;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: $select-font-size;
}
.multiselect__select:before {
  border-color: $protective-blue transparent transparent transparent; // #2787fa
}
.multiselect__content-wrapper {
  min-width: 260px;
  border-top: 1px solid #e8e8e8;
  border-radius: 5px;
  width: auto;
  right: 0;
}
.multiselect__option--highlight {
  background-color: $protective-blue;
}
.multiselect__option--selected {
  &.multiselect__option--highlight {
    background-color: $light-gray;
  }
}
</style>
